import L, { LatLngExpression, LatLngBounds } from 'leaflet';
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureGroup, MapContainer, TileLayer, useMap, Polygon } from 'react-leaflet';
import { EditControl } from "react-leaflet-draw";
import { getCookie } from 'typescript-cookie';
import KyLokal from '../../components/changeLang/drawLocalesKy';
import RuLokal from '../../components/changeLang/drawLocalesRu';

interface IProps {
  setPolygon: (polygon: string | null) => void;
  polygon?: string | null;
}

export const MapAddPolygon = (props: IProps) => {
  const { t } = useTranslation();
  const defaultCenter: LatLngExpression = [42.87, 74.59];
  const [mapCenter, setMapCenter] = useState<LatLngExpression>(defaultCenter);
  const [polygonCoordinates, setPolygonCoordinates] = useState<[number, number][] | null>(null);

  (L as any).drawLocal = getCookie("i18next") === 'ky' ? KyLokal : RuLokal;

  useEffect(() => {
    if (props.polygon) {
      try {
        const latlngs: [number, number][] = JSON.parse(props.polygon);
        setPolygonCoordinates(latlngs);
      } catch (error) {
        console.error("Error parsing polygon:", error);
        
      }
    }
  }, [props.polygon]);

  const _onCreated = (e: any) => {
    const { layer } = e;
    if (layer instanceof L.Polygon) {
      const latlngs = (layer.getLatLngs()[0] as L.LatLng[]).map(
        (latlng: L.LatLng) => [latlng.lat, latlng.lng] as [number, number]
      );
      const polygonString = JSON.stringify(latlngs);
      props.setPolygon(polygonString);
    }
  };

  const _onEdited = (e: any) => {
    const layers = e.layers;
    layers.eachLayer((layer: any) => {
      if (layer instanceof L.Polygon) {
        const latlngs = layer.getLatLngs();
        if (Array.isArray(latlngs) && Array.isArray(latlngs[0])) {
          const coordinates = (latlngs[0] as L.LatLng[]).map(
            (latlng: L.LatLng) => [latlng.lat, latlng.lng] as [number, number]
          );
          const polygonString = JSON.stringify(coordinates);
          props.setPolygon(polygonString);
        }
      }
    });
  };

  const _onDeleted = () => {
    props.setPolygon(null);
  };

  const ChangeMapView = () => {
    const map = useMap();

    useEffect(() => {
      map.invalidateSize();  // Force map redraw

      if (polygonCoordinates && polygonCoordinates.length > 0) {
        // Test fitBounds only if polygonCoordinates exist
        const bounds = new L.LatLngBounds(polygonCoordinates);
        map.fitBounds(bounds);
      } else {
        map.setView(mapCenter, 13);  // Set fallback center and zoom
      }
    }, [mapCenter, map, polygonCoordinates]);

    return null;
  };

  return (
    <div style={{ marginBottom: "15px" }}>
      <h4>{t("map.borders")}:</h4>
      <MapContainer
        center={mapCenter}
        zoom={13}
        style={{ height: '300px', width: "100%" }}
        scrollWheelZoom={true}
        zoomControl={false}
        
      >
        <FeatureGroup>
          <EditControl
            position='topright'
            draw={{
              rectangle: false,
              polyline: false,
              polygon: true,
              circle: false,
              circlemarker: false,
              marker: false,
            }}
            onCreated={_onCreated}
            onEdited={_onEdited}
            onDeleted={_onDeleted}
          />
          {polygonCoordinates && (
            <Polygon positions={polygonCoordinates} />
          )}
        </FeatureGroup>
        <ChangeMapView />
      <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </MapContainer>
    </div>
  );
};
